import { Flex, Text, Title } from '@mantine/core';
import { CompanyLevelBadge, formatCompanyRating } from '@entities/company';
import { pluralize } from '@shared/utils';
import classes from './CompanyRating.module.scss';

type CompanyRatingProps = {
  rating?: number | string | null;
  level?: string | null;
};

export const CompanyRating = ({ rating, level }: CompanyRatingProps) => {
  const formattedRating = formatCompanyRating(rating);
  const numericRating = Number(formattedRating);
  const unit = pluralize(numericRating, ['балл', 'балла', 'баллов']);

  return (
    <Flex
      className={classes.wrapper}
      direction='column'
      gap={16}
      maw={418}
      miw={{ base: 'auto', sm: '25.5rem' }}
      p={24}
    >
      <Text size='lg' fw={600}>
        Рейтинг компании
      </Text>

      <Flex
        className={classes.ratingBar}
        gap={24}
        align='center'
        justify='space-between'
        wrap='wrap'
      >
        <CompanyLevelBadge level={level} />

        <Title order={4} lh='24px' pr={12}>
          {formattedRating} {unit}
        </Title>
      </Flex>
    </Flex>
  );
};
